var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { first } from 'lodash';
import { ChevronRightThinIconGlyph, LinkedinFilledIconGlyph, SiteIcon, TwitterFilledIconGlyph } from '@shapeable/icons';
import { EntityLinkButton } from './entity-link-button';
import { useLink } from '../hooks/use-link';
import { useLang } from '../hooks/use-lang';
var cls = classNames('person-card-meta');
export var PersonCardMetaDefaultProps = {
  showOrganisation: true,
  showCountry: true,
  useProfile: true,
  useTooltip: false
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    font-weight: 400;\n  "], ["\n    font-weight: 400;\n  "])))
});
var BodyStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var InfoStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n  "], ["\n    display: flex;\n    flex-direction: column;\n  "])))
});
var LinksStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: flex-start;\n    flex-direction: row;\n    gap: ", ";\n    margin-top: ", ";\n  "], ["\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: flex-start;\n    flex-direction: row;\n    gap: ", ";\n    margin-top: ", ";\n  "])), theme.UNIT(2), theme.UNIT(2))
});
var PositionStyles = breakpoints({
  base: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    font-weight: inherit;\n    color: ", ";\n  "], ["\n    font-weight: inherit;\n    color: ", ";\n  "])), theme.COLOR('text'))
});
var CountryStyles = breakpoints({
  base: css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    font-weight: inherit;\n  "], ["\n    font-weight: inherit;\n  "])))
});
var OrganisationStyles = breakpoints({
  base: css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var ProfileButtonStyles = breakpoints({
  base: css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    line-height: 1.1em;\n    font-size: ", ";\n\n   .shp--button {\n      background: ", ";\n      color: ", ";\n      border-style: solid;\n      border-width: 1px;\n      padding-bottom: 4px;\n      padding-top: 4px;\n      border-color: ", ";\n    }\n  "], ["\n    line-height: 1.1em;\n    font-size: ", ";\n\n   .shp--button {\n      background: ", ";\n      color: ", ";\n      border-style: solid;\n      border-width: 1px;\n      padding-bottom: 4px;\n      padding-top: 4px;\n      border-color: ", ";\n    }\n  "])), theme.FONT_SIZE(12), theme.COLOR('light'), theme.COLOR('dark'), theme.COLOR('strong'))
});
var BioButtonStyles = breakpoints({
  base: css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
// -------- Components -------->
var My = {
  Container: styled.div(templateObject_10 || (templateObject_10 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Body: styled.div(templateObject_11 || (templateObject_11 = __makeTemplateObject(["", ""], ["", ""])), BodyStyles),
  Info: styled.div.attrs(cls.attr('info'))(templateObject_12 || (templateObject_12 = __makeTemplateObject(["", ""], ["", ""])), InfoStyles),
  Position: styled.span.attrs(cls.attr('position'))(templateObject_13 || (templateObject_13 = __makeTemplateObject(["", ""], ["", ""])), PositionStyles),
  Organisation: styled.span.attrs(cls.attr('organisation'))(templateObject_14 || (templateObject_14 = __makeTemplateObject(["", ""], ["", ""])), OrganisationStyles),
  Country: styled.span.attrs(cls.attr('country'))(templateObject_15 || (templateObject_15 = __makeTemplateObject(["", ""], ["", ""])), CountryStyles),
  Links: styled.div.attrs(cls.attr('links'))(templateObject_16 || (templateObject_16 = __makeTemplateObject(["", ""], ["", ""])), LinksStyles),
  ProfileButton: styled(EntityLinkButton).attrs(cls.attr('profile-button'))(templateObject_17 || (templateObject_17 = __makeTemplateObject(["", ""], ["", ""])), ProfileButtonStyles),
  BioButton: styled(EntityLinkButton).attrs(cls.attr('bio-button'))(templateObject_18 || (templateObject_18 = __makeTemplateObject(["", ""], ["", ""])), BioButtonStyles)
};
export var PersonCardMeta = function (props) {
  var className = props.className,
    children = props.children,
    entity = props.entity,
    showOrganisation = props.showOrganisation,
    showCountry = props.showCountry,
    useProfile = props.useProfile,
    useTooltip = props.useTooltip;
  var _a = entity || {},
    position = _a.position,
    organisation = _a.organisation,
    twitter = _a.twitter,
    linkedin = _a.linkedin,
    websiteUrl = _a.websiteUrl,
    bio = _a.bio,
    path = _a.path,
    badge = _a.badge;
  var economy = (entity === null || entity === void 0 ? void 0 : entity.economy) || (entity === null || entity === void 0 ? void 0 : entity.country) || first(entity.economies || []);
  var Link = useLink().Link;
  var t = useLang();
  var hasOrganisation = showOrganisation && !!organisation && organisation.name;
  var hasWebsite = !!websiteUrl;
  var hasCountry = showCountry && !!economy;
  var hasBio = !!(bio && bio.html);
  var hasProfile = useProfile && !!path;
  var shouldOpenWebsite = (!hasBio || !useTooltip) && hasWebsite;
  // Adjusted logic so that profile || website || bio can be clicked from top and linked accordingly.
  var clickInfo = shouldOpenWebsite ? {
    url: websiteUrl,
    newTab: true
  } : hasProfile ? {
    url: path,
    newTab: false
  } : null;
  var onClick = clickInfo ? function () {
    return window.open(clickInfo.url, clickInfo.newTab ? '_blank' : '_self');
  } : function () {};
  var tooltipProps = useTooltip && hasBio ? {
    "data-event": "click",
    "data-tip": bio && bio.html || '',
    "data-html": true
  } : {};
  var swallowEvent = function (event) {
    event.stopPropagation();
  };
  return React.createElement(My.Container, __assign({
    onClick: onClick
  }, tooltipProps, {
    className: cls.name(className)
  }), React.createElement(My.Body, null, React.createElement(My.Info, null, position && React.createElement(My.Position, null, position), hasOrganisation && React.createElement(My.Organisation, null, organisation === null || organisation === void 0 ? void 0 : organisation.name), hasCountry && React.createElement(My.Country, null, economy === null || economy === void 0 ? void 0 : economy.name)), React.createElement(My.Links, null, twitter && React.createElement(Link, {
    onClick: swallowEvent,
    title: t('Twitter'),
    href: twitter,
    target: "_blank"
  }, React.createElement(TwitterFilledIconGlyph, {
    size: 24
  })), linkedin && React.createElement(Link, {
    onClick: swallowEvent,
    title: t('Linkedin'),
    href: linkedin,
    target: "_blank"
  }, React.createElement(LinkedinFilledIconGlyph, {
    size: 24
  })), hasWebsite && React.createElement(Link, {
    onClick: swallowEvent,
    title: t('Website'),
    href: websiteUrl,
    target: "_blank"
  }, React.createElement(SiteIcon, {
    size: 24
  })), hasProfile ? React.createElement(My.ProfileButton, {
    variant: 'micro',
    shape: 'rounded',
    borderStyle: 'solid',
    icon: ChevronRightThinIconGlyph,
    entity: entity
  }, t('Profile')) : hasBio && React.createElement(My.BioButton, {
    variant: 'micro',
    shape: 'rounded',
    entity: entity
  }, t('Bio')))), children);
};
PersonCardMeta.defaultProps = PersonCardMetaDefaultProps;
PersonCardMeta.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18;